// extracted by mini-css-extract-plugin
export var component = "Services-module--component--Hnqod";
export var current = "Services-module--current--bxvlz";
export var label = "Services-module--label--KXOAz";
export var link = "Services-module--link--feUqe";
export var linkIcon = "Services-module--linkIcon--3zsdk";
export var list = "Services-module--list--5TyMp";
export var roundIcon = "Services-module--roundIcon--VK3jV";